import { gql } from '@apollo/client';

export const JOURNEY_TYPE = gql`
  query journeyType {
    journeyType
  }
`;
